module.exports = require('./helpers/bundle-url').getBundleURL('7v8lJ') + "logo-dark.eefe0b7f.svg";